import { useNewsletter } from '@allesauto/utils/apiHooks';
import { useCallback, useState } from 'react';

import NewsletterSubscribeCheckbox from '@/components/forms/NewsletterForms/NewsletterSubscribeCheckbox';

interface UseNewsletterSubscribeCheckbox {
  isDarkBg?: boolean;
}

export default function useNewsletterSubscribeCheckbox({
  isDarkBg,
}: UseNewsletterSubscribeCheckbox | undefined = {}) {
  const [checked, setChecked] = useState(false);

  const [
    sendNewsletterRequest,
    {
      result: subscribeResult,
      loading: subscribeLoading,
      error: subscribeError,
    },
  ] = useNewsletter();

  const subscribe = useCallback(
    async ({
      email,
      source,
    }: Pick<
      Parameters<typeof sendNewsletterRequest>['0'],
      'email' | 'source'
    >) => {
      if (checked) {
        await sendNewsletterRequest({
          type: 'subscribe',
          email,
          source,
        });
      }
    },
    [checked, sendNewsletterRequest]
  );

  const checkboxProps = {
    checked,
    onChange: setChecked,
    isDarkBg,
  };

  return {
    NewsletterSubscribeCheckbox,
    checkboxProps,
    subscribe,
    subscribeResult,
    subscribeLoading,
    subscribeError,
  };
}
